<template>
    <nut-popup v-model:visible="visible" style="background-color: transparent" :close-on-click-overlay="false">
        <div class="dialog-content">
            <div class="content-box">
                <div class="title">加入队伍</div>
                <div class="desc">
                    少侠确认要加入{{ team_share_data.urs }}的团队嘛？每个少侠只能加入一个团队噢
                </div>
                <TxButton src="anniu_2" class="t-btn" name="确定加入队伍" @click="comfirmJoin">
                    确定
                </TxButton>
            </div>
            <div class="close-box">
                <TxButton src="gb" name="关闭加入队伍弹窗" @click="closeModal">
                </TxButton>
            </div>
        </div>
    </nut-popup>
</template>

<script lang="ts" setup>
import { ref, inject } from 'vue';
import eventEmitter from '@utils/event';
import useWeChatEnv from '@/plugins/vue/useWeChatOrMiniProgram';
import { join_team } from '@utils/api';
const { set_invite_id } = inject('GlobalStore');
const { init_data, set_team_share_data, team_share_data, login_status, error_codemsg } = inject('GlobalData');

const { isWeChat, isMiniProgram } = useWeChatEnv();

const visible = ref(false)
const loading = ref(false)

eventEmitter.on('showJoinTeamModal', () => {
    visible.value = true
});
eventEmitter.on('closeJoinTeamModal', () => {
    visible.value = false
});

function closeModal() {
    visible.value = false
    set_team_share_data({})
    set_invite_id('')
}

function beforeCheck() {
    // if (!(isMiniProgram.value || isWeChat.value)) {
    //     // eventEmitter.emit('toast', {
    //     //     text: '请使用微信打开此活动',
    //     //     duration: 2,
    //     // });
    //     eventEmitter.emit('showCommomTipModal', 'copyLink');
    //     return false
    // }
    if (!login_status.value) {
        eventEmitter.emit('login');
        return false
    }
    if (!!error_codemsg.value) {
        eventEmitter.emit('toast', {
            text: error_codemsg.value,
        });
        return false
    }
    return true
}

function comfirmJoin() {
    const ispass = beforeCheck()
    if (!ispass) return
    if (loading.value) return
    loading.value = true
    if (!!init_data.act_data.team_id) {
        eventEmitter.emit('toast', {
            text: '您已经有队伍，无法加入其他队伍',
            duration: 2,
        });
        return
    }
    join_team({
        share_id: team_share_data.value.id
    }).then(res => {
        loading.value = false
        if (res.code !== 1) {
            eventEmitter.emit('toast', {
                text: res.errorMsg,
            });
            return
        }
        eventEmitter.emit('toast', {
            text: res.errorMsg,
        });
        closeModal()
        eventEmitter.emit('refresh_taskList_bus');
        eventEmitter.emit('refresh_init_bus');
    })
}
</script>

<style lang="scss" scoped>
.dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;

    .content-box {
        @include bg('db_9');
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding-top: 60px;
        padding-bottom: 120px;

        .title {
            font-size: 40px;
            color: #fff;
        }

        .desc {
            @include bg('tczidb');
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #202631;
            box-sizing: border-box;
            padding: 0 60px;
            text-align: center;
        }
    }

    .close-box {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        .close-icon {
            color: #fff;
        }
    }
}
</style>